import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import PropTypes from 'prop-types';
import React from 'react';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

export default function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.Tags?.map((tag) => {
            if (tag.Key === 'Name') return tag.Value;
            return null;
          })}
        </TableCell>
        <TableCell align="right">{row.State?.Name}</TableCell>
        <TableCell align="right">{row.InstanceId}</TableCell>
        <TableCell align="right">
          {row.Tags?.map((tag) => {
            if (tag.Key === 'ResourceId') return tag.Value;
            return null;
          })}
        </TableCell>
        <TableCell align="right">
          {/* <button onClick={() => stopECSTask(row.taskArn)}>Stop</button> */}
        </TableCell>
        <TableCell align="right">
          {/* <button
            onClick={async () => {
              await stopECSTask(row.taskArn);
              await startStreamingTask(
                row.overrides?.containerOverrides?.[0].environment?.[0].value,
                row.overrides?.containerOverrides?.[0].environment?.[1].value
              );
            }}
          >
            Restart
          </button> */}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div>
                SSH: {`ssh -i "ec2.pem" ubuntu@${row.PublicDnsName}`}
                <pre>{JSON.stringify(row, null, 2)}</pre>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.object,
};
